import useToastStore from '../components/app-layout/toastStore';

// Fetches a download link, opens it and reports the result in a toast.
// pendingMessage shows a toast while the link is fetched, for callers without their own loading state
export default async function downloadFromUrl(
  fetchUrl: () => Promise<string>,
  pendingMessage?: string,
): Promise<void> {
  const { showToast } = useToastStore.getState();
  if (pendingMessage) showToast(pendingMessage, 'info');
  try {
    const url = await fetchUrl();
    window.open(url, '_blank');
    showToast('Success! Please check your downloads folder', 'success');
  } catch (error) {
    showToast(error instanceof Error ? error.message : 'An error occurred', 'error');
  }
}
